// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backups-page {
    padding: 24px;
    max-width: 1200px;
}

.backups-page h2 {
    margin: 0 0 10px 0;
    color: #333;
    font-size: 24px;
}

.backups-page .page-subtitle {
    color: #666;
    font-size: 14px;
    margin-bottom: 24px;
}

/* ── Settings card ── */

.backups-settings-card {
    background: white;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
}

.backups-settings-card h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 10px;
}

.settings-form {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: flex-end;
}

.settings-form .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 140px;
}

.settings-form .form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #666;
}

.settings-form .form-group input,
.settings-form .form-group select {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
}

.settings-form .form-group input:focus,
.settings-form .form-group select:focus {
    border-color: #4a90d9;
}

.settings-form .toggle-group {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 4px;
}

.settings-form .toggle-group label {
    font-size: 13px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
}

.settings-form .toggle-group input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

/* ── Buttons ── */

.btn {
    padding: 8px 18px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s, opacity 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-primary {
    background: #4a90d9;
    color: white;
}

.btn-primary:hover:not(:disabled) {
    background: #357abd;
}

.btn-success {
    background: #4caf50;
    color: white;
}

.btn-success:hover:not(:disabled) {
    background: #43a047;
}

.btn-danger {
    background: #f44336;
    color: white;
}

.btn-danger:hover:not(:disabled) {
    background: #e53935;
}

.btn-secondary {
    background: #f0f0f0;
    color: #333;
}

.btn-secondary:hover:not(:disabled) {
    background: #e0e0e0;
}

.btn-sm {
    padding: 5px 12px;
    font-size: 12px;
}

/* ── Actions bar ── */

.backups-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 12px;
}

.backups-actions .filter-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.backups-actions .filter-group label {
    font-size: 13px;
    color: #666;
    font-weight: 600;
}

.backups-actions .filter-group select {
    padding: 6px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 13px;
}

/* ── Table ── */

.backups-table-wrapper {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow-x: auto;
}

.backups-table {
    width: 100%;
    border-collapse: collapse;
}

.backups-table th,
.backups-table td {
    text-align: left;
    padding: 12px 16px;
    font-size: 13px;
    white-space: nowrap;
}

.backups-table th {
    background: #f7f8fa;
    color: #555;
    font-weight: 600;
    border-bottom: 2px solid #e0e0e0;
    position: sticky;
    top: 0;
}

.backups-table tbody tr {
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.15s;
}

.backups-table tbody tr:hover {
    background: #f8faff;
}

/* ── Status badges ── */

.backup-status {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: capitalize;
}

.backup-status.completed {
    background: #e8f5e9;
    color: #2e7d32;
}

.backup-status.in_progress,
.backup-status.pending {
    background: #fff3e0;
    color: #e65100;
}

.backup-status.failed {
    background: #ffebee;
    color: #c62828;
}

.backup-status.deleted {
    background: #f5f5f5;
    color: #9e9e9e;
}

.backup-type {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
}

.backup-type.scheduled {
    background: #e3f2fd;
    color: #1565c0;
}

.backup-type.manual {
    background: #f3e5f5;
    color: #7b1fa2;
}

.s3-badge {
    font-size: 11px;
    font-weight: 600;
}

.s3-badge.uploaded {
    color: #4caf50;
}

.s3-badge.not-uploaded {
    color: #bdbdbd;
}

/* ── Pagination ── */

.backups-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 16px;
}

.backups-pagination .page-info {
    font-size: 13px;
    color: #666;
}

/* ── Loading / Empty ── */

.backups-loading,
.backups-empty {
    text-align: center;
    padding: 48px 24px;
    color: #999;
    font-size: 14px;
}

.backups-error {
    text-align: center;
    padding: 48px 24px;
    color: #c62828;
    font-size: 14px;
}

/* ── Confirm modal ── */

.confirm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.confirm-modal {
    background: white;
    border-radius: 12px;
    padding: 28px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.confirm-modal h4 {
    margin: 0 0 12px 0;
    font-size: 18px;
    color: #333;
}

.confirm-modal p {
    margin: 0 0 20px 0;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
}

.confirm-modal .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

/* ── Responsive ── */

@media (max-width: 768px) {
    .backups-page {
        padding: 16px;
    }

    .settings-form {
        flex-direction: column;
    }

    .backups-actions {
        flex-direction: column;
        align-items: flex-start;
    }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/DatabaseBackups.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA,wBAAwB;;AAExB;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,kBAAkB;;AAElB;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,+CAA+C;IAC/C,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA,sBAAsB;;AAEtB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,gBAAgB;;AAEhB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;;AAExB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,0BAA0B;;AAE1B;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,wBAAwB;;AAExB;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA,qBAAqB;;AAErB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".backups-page {\n    padding: 24px;\n    max-width: 1200px;\n}\n\n.backups-page h2 {\n    margin: 0 0 10px 0;\n    color: #333;\n    font-size: 24px;\n}\n\n.backups-page .page-subtitle {\n    color: #666;\n    font-size: 14px;\n    margin-bottom: 24px;\n}\n\n/* ── Settings card ── */\n\n.backups-settings-card {\n    background: white;\n    padding: 24px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 24px;\n}\n\n.backups-settings-card h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 18px;\n    border-bottom: 2px solid #e0e0e0;\n    padding-bottom: 10px;\n}\n\n.settings-form {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    align-items: flex-end;\n}\n\n.settings-form .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 140px;\n}\n\n.settings-form .form-group label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #666;\n}\n\n.settings-form .form-group input,\n.settings-form .form-group select {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.settings-form .form-group input:focus,\n.settings-form .form-group select:focus {\n    border-color: #4a90d9;\n}\n\n.settings-form .toggle-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-bottom: 4px;\n}\n\n.settings-form .toggle-group label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #666;\n    cursor: pointer;\n}\n\n.settings-form .toggle-group input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n/* ── Buttons ── */\n\n.btn {\n    padding: 8px 18px;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s, opacity 0.2s;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.btn-primary {\n    background: #4a90d9;\n    color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n    background: #357abd;\n}\n\n.btn-success {\n    background: #4caf50;\n    color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n    background: #43a047;\n}\n\n.btn-danger {\n    background: #f44336;\n    color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n    background: #e53935;\n}\n\n.btn-secondary {\n    background: #f0f0f0;\n    color: #333;\n}\n\n.btn-secondary:hover:not(:disabled) {\n    background: #e0e0e0;\n}\n\n.btn-sm {\n    padding: 5px 12px;\n    font-size: 12px;\n}\n\n/* ── Actions bar ── */\n\n.backups-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.backups-actions .filter-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.backups-actions .filter-group label {\n    font-size: 13px;\n    color: #666;\n    font-weight: 600;\n}\n\n.backups-actions .filter-group select {\n    padding: 6px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 13px;\n}\n\n/* ── Table ── */\n\n.backups-table-wrapper {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    overflow-x: auto;\n}\n\n.backups-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.backups-table th,\n.backups-table td {\n    text-align: left;\n    padding: 12px 16px;\n    font-size: 13px;\n    white-space: nowrap;\n}\n\n.backups-table th {\n    background: #f7f8fa;\n    color: #555;\n    font-weight: 600;\n    border-bottom: 2px solid #e0e0e0;\n    position: sticky;\n    top: 0;\n}\n\n.backups-table tbody tr {\n    border-bottom: 1px solid #f0f0f0;\n    transition: background-color 0.15s;\n}\n\n.backups-table tbody tr:hover {\n    background: #f8faff;\n}\n\n/* ── Status badges ── */\n\n.backup-status {\n    display: inline-block;\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.backup-status.completed {\n    background: #e8f5e9;\n    color: #2e7d32;\n}\n\n.backup-status.in_progress,\n.backup-status.pending {\n    background: #fff3e0;\n    color: #e65100;\n}\n\n.backup-status.failed {\n    background: #ffebee;\n    color: #c62828;\n}\n\n.backup-status.deleted {\n    background: #f5f5f5;\n    color: #9e9e9e;\n}\n\n.backup-type {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.backup-type.scheduled {\n    background: #e3f2fd;\n    color: #1565c0;\n}\n\n.backup-type.manual {\n    background: #f3e5f5;\n    color: #7b1fa2;\n}\n\n.s3-badge {\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.s3-badge.uploaded {\n    color: #4caf50;\n}\n\n.s3-badge.not-uploaded {\n    color: #bdbdbd;\n}\n\n/* ── Pagination ── */\n\n.backups-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    padding: 16px;\n}\n\n.backups-pagination .page-info {\n    font-size: 13px;\n    color: #666;\n}\n\n/* ── Loading / Empty ── */\n\n.backups-loading,\n.backups-empty {\n    text-align: center;\n    padding: 48px 24px;\n    color: #999;\n    font-size: 14px;\n}\n\n.backups-error {\n    text-align: center;\n    padding: 48px 24px;\n    color: #c62828;\n    font-size: 14px;\n}\n\n/* ── Confirm modal ── */\n\n.confirm-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.confirm-modal {\n    background: white;\n    border-radius: 12px;\n    padding: 28px;\n    max-width: 420px;\n    width: 90%;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.confirm-modal h4 {\n    margin: 0 0 12px 0;\n    font-size: 18px;\n    color: #333;\n}\n\n.confirm-modal p {\n    margin: 0 0 20px 0;\n    color: #666;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.confirm-modal .modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 768px) {\n    .backups-page {\n        padding: 16px;\n    }\n\n    .settings-form {\n        flex-direction: column;\n    }\n\n    .backups-actions {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
